// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Ecuador */
const EC = /^(?:964[0-2]\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\d)\d{6})$/;

export default EC;
